import React from 'react';
import BaseTablePage from '../../elements/BaseTablePage'
import Pagination from '../../elements/Pagination'

import { CeremonyTableUI } from './CeremonyTableUI'
import { ChanceTable } from '../chance/ChanceTable'
//import { GhorePrizePage } from '../../components/GhorePrizePage'


export class CeremonyTable extends BaseTablePage {

  constructor(props) {
    super(props);
    this.getDataUrl = "api/v1/GetCeremony?offset=";
    //    this.getExcelUrl = "/api/v1/GetProductReportExcel";
    this.className = "CeremonyReport";
    this.state.mode = "table";
    this.state.searchData = { id: 0 };

    this.onStartClick = this.onStartClick.bind(this);
    this.onCalculateClick = this.onCalculateClick.bind(this);
    this.onDisable = this.onDisable.bind(this);
    this.onShowChances = this.onShowChances.bind(this);
    this.headers["ghoreId"] = this.props.ghoreId;

  }

  onStartClick(e) {

    if (typeof this.props.onStartClick === "function") {
      this.props.onStartClick(e);

    }
  }
  onCalculateClick(e) {
    var b = { Id: e };
    console.log(b);
    fetch('api/v1/CalculateCeremony',
      {
        method: 'POST',
        body: JSON.stringify(b),
        headers: this.headers
      }).then(res => {
        this.status = res.status;
        console.log(this.status);

        if (this.status == 401) {
          localStorage.setItem('token', null);
          window.location.reload(false);

        }

        res.json().then((result) => {


          if (this.status == 200) {

            // this.state.isLoaded = true;
            // this.setState({});

            alert("درخواست با موفقیت ثبت شد");

          }
          else {
            console.log(result);
            alert(result.Value);
          }

        },
          (error) => {

          }
        );
      }
      );
  }
  onDisable(e) {

    var b = { Id: e };


    if (window.confirm('آیا از ابطال قرعه کشی اطمینان دارید؟'))
    {
      console.log(b);
      fetch('api/v1/DisableCeremony',
        {
          method: 'POST',
          body: JSON.stringify(b),
          headers: this.headers
        }).then(res => {
          this.status = res.status;
          console.log(this.status);
  
          if (this.status == 401) {
            localStorage.setItem('token', null);
            window.location.reload(false);
  
          }
  
          res.json().then((result) => {
  
  
            if (this.status == 200) {
  
              // this.state.isLoaded = true;
              // this.setState({});
  
              alert("عملیات با موفقیت انجام شد");
  
              if (typeof this.props.onDisable === "function") {
                this.props.onDisable(e);
  
              }
  
            }
            else {
              console.log(result);
              alert(result.Value);
            }
  
          },
            (error) => {
  
            }
          );
        }
        );
         
    }

   
  }
  onShowChances(e,d) {
    console.log("onShowChances");
    this.state.mm = "showChance";
    this.state.ceremonyId = e;
    this.state.ceremonyLotteryKind=d;
    this.setState({});
  }


  render() {
    if (this.state.mm == "showChance") {
      return <ChanceTable ceremonyId={this.state.ceremonyId}  ceremonyLotteryKind={this.state.ceremonyLotteryKind}/>
    }
    //  if (!this.state.isLoaded) {
    //  return <div className="box-body"> در حال بارگذاری</div>;
    // }

    //console.log()
    return (
      <div className="container">
        <CeremonyTableUI data={this.state.data} onStartClick={this.onStartClick} onCalculateClick={this.onCalculateClick} onShowChances={this.onShowChances} onDisable={this.onDisable} onViewClick={this.onViewClick} />
        <Pagination pageNumber={this.state.pageNumber} count={this.state.count} perPageCount={this.state.pageSize} onChange={this.handleChangePage} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/tables/ceremony/CeremonyTable.js